<content>
    <section id="big-modal" >
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal" [ngClass]="{'show-one-error': showLengthErrorDes}">
            <label>{{'global.finca' | translate}} *</label>
            <!-- estilo para iPad -->
            <input type="text" formControlName="des" style="margin-bottom: unset">
        </div>
        <div class="entry-4-modal">
            <label>{{'global.pais' | translate}} *</label>
            <app-filterable-list class="no-margin" [ngClass]="role === 'Auditor' ? 'shorter-list' : 'short-list'" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabledPais" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'global.provincia' | translate}} *</label>
            <app-filterable-list class="no-margin" [ngClass]="role === 'Auditor' ? 'shorter-list' : 'short-list'" [itemsList]="provinciasList" [selectedItem]="newEditForm.get('provincia')" [disabled]="disabledProvincia" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'global.municipio' | translate}} *</label>
            <app-filterable-list class="no-margin shorter-list" [itemsList]="municipiosList" [selectedItem]="newEditForm.get('municipio')" [disabled]="disabledMunicipio" [placeHolder]="false"></app-filterable-list>
        </div>
        <div *ngIf= "role === 'Administrador'" class="entry-4-modal alignment-start">
            <input type="checkbox" id="visible_new" formControlName="visible_new">
            <label for="visible_new">{{'mantenimientoCultivos.finca.visible' | translate}}</label>
        </div>
        <div *ngIf= "role === 'Administrador'" class="entry-4-modal alignment-start">
            <input type="checkbox" id="fincaDePrueba_new" formControlName="fincaDePrueba_new">
            <label for="fincaDePrueba_new">{{'mantenimientoCultivos.finca.fincaPrueba' | translate}}</label>
        </div>
    </form>
    </section>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{fincaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
